import script from "./WaktuAcara.vue?vue&type=script&setup=true&lang=js"
export * from "./WaktuAcara.vue?vue&type=script&setup=true&lang=js"

import "./WaktuAcara.vue?vue&type=style&index=0&id=0e310b65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e310b65"]])

export default __exports__